import { disambiguateExcelHeaders } from './disambiguateExcelHeaders';

export const mapExcelRowsToObjects = (
  headers: (string | number | null | undefined)[],
  rows: unknown[][]
): Record<string, unknown>[] => {
  const normalizedHeaders = disambiguateExcelHeaders(headers);

  return rows.map((row) => {
    const rowObject: Record<string, unknown> = {};

    normalizedHeaders.forEach((headerKey, index) => {
      if (!headerKey) return;

      rowObject[headerKey] = row?.[index] ?? '';
    });

    return rowObject;
  });
};
